module.exports = __webpack_public_path__ + "img/tree-08-a-leaves.fc28b002.png";